export const Results = () => (
    <div className="container-fluid">
        <div className="row">
            <div className="col-12">
                <img src="/images/results/results.png" className="img-fluid" />
            </div>
        </div>
    </div>
)